import { render } from "./paymentPlans.vue?vue&type=template&id=54cbc622&scoped=true"
import script from "./paymentPlans.vue?vue&type=script&lang=js"
export * from "./paymentPlans.vue?vue&type=script&lang=js"

import "./less/paymentPlans.less?vue&type=style&index=0&id=54cbc622&scoped=true&lang=css&external"
import "./paymentPlans.vue?vue&type=style&index=1&id=54cbc622&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54cbc622"]])

export default __exports__